import styled from "styled-components";


export const OrderItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border: 1px solid #e4e7ed;
    border-radius: 6px;
    margin-bottom: 8px;
    background-color: #fafbfc;
    font-family: "Roboto";
    font-size: 14px;
    color: #2d3748;
`;

export const OrderItemLabel = styled.span`
    font-weight: 500;
`;

export const SwapButton = styled.button<{ $isAnimating?: boolean }>`
    background: none;
    border: none;
    cursor: pointer;
    font-size: 18px;
    color: #595959;
    padding: 4px 8px;
    border-radius: 4px;
    pointer-events: ${({ $isAnimating }) => ($isAnimating ? "none" : "auto")};
    &:hover {
        background-color: ${({ $isAnimating }) => ($isAnimating ? "transparent" : "#e4e7ed")};
    }
    &:disabled {
        cursor: not-allowed;
        opacity: 0.3;
        background-color: transparent;
    }
`;

export const ActionButtonComponent = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 24px;
`;
